import heroImage from "../assets/hero.jpg";

export const Hero = () => (
  <section
    className="relative h-screen text-white flex flex-col items-center justify-center text-center px-4 bg-cover bg-center"
    style={{ backgroundImage: `url(${heroImage})` }}
  >
    <div className="bg-black bg-opacity-50 p-8 rounded-xl backdrop-blur-md max-w-3xl w-full mx-4">
      <h1 className="text-5xl font-bold mb-4">Train. Certify. Lead.</h1>
      <p className="text-xl mb-6">Industry-leading lifeguard and first aid certification in Toronto.</p>
      <div className="flex gap-4 justify-center flex-wrap">
        <a href="#Programs" className="bg-orange-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-orange-600 transition">
          View Courses
        </a>
        <a href="#Register" className="bg-white text-blue-800 px-6 py-3 rounded-full font-semibold hover:bg-gray-200 transition">
          Register Now
        </a>
      </div>
    </div>
  </section>
);
export default Hero;
